var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoveItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "move_item_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#move_item_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "M13.433 8.667H6a.645.645 0 0 1-.475-.192A.645.645 0 0 1 5.333 8c0-.189.064-.347.192-.475A.645.645 0 0 1 6 7.333h7.433l-.566-.566a.61.61 0 0 1-.192-.467.68.68 0 0 1 .667-.675.62.62 0 0 1 .475.192l1.716 1.716a.64.64 0 0 1 .2.467.64.64 0 0 1-.2.467l-1.716 1.716a.62.62 0 0 1-.475.192.68.68 0 0 1-.667-.675.61.61 0 0 1 .192-.467l.566-.566ZM10 5.333v-2H3.333v9.334H10v-2c0-.19.064-.348.192-.475a.645.645 0 0 1 .475-.192c.189 0 .347.064.475.192a.645.645 0 0 1 .191.475v2c0 .366-.13.68-.391.941A1.284 1.284 0 0 1 10 14H3.333c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 12.667V3.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392H10c.367 0 .68.13.942.392.26.26.391.575.391.941v2a.645.645 0 0 1-.191.475.645.645 0 0 1-.475.192.645.645 0 0 1-.475-.192.645.645 0 0 1-.192-.475Z"
}))));
export default SvgMoveItem;